import React, { useContext } from "react";
import {
    Grid,
    FormControl,
    FormLabel,
    TextField,
    Button,
    Divider,
    Typography,
    Link,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Controller } from "react-hook-form";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import LoadingScreen from "components/common/LoadingScreen";
import LockPromptDialog from "components/common/LockPromptDialog";
import { LoginViewContext } from "components/ResetPwdNew.page";
import { useStyles } from "../login/Login.page.style";
import login_bg_mobile from "images/login_bg_mobile.png";
import LoginIcon from "images/loginIcon.png";

const ResetPwdMobile = () => {
    const {
        register,
        isLoading,
        theme,
        usefulInfo,
        logoLink,
        handleSubmit,
        onSubmit,
        control,
        errors,
        showLockTip,
        lockTipContent,
        handleMouseDownPassword,
        showConfirmPassword,
        handleClickShowConfirmPassword,
        showNewPassword,
        handleClickShowNewPassword,
        handleLockClose,
    } = useContext(LoginViewContext);

    const classes = useStyles();

    return (
        <div style={{ height: "100%", overflow: "hidden", position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
            <div style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
                <LoadingScreen open={isLoading} />
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <Grid container className={classes.fullHeight} flexWrap={"nowrap"}>
                            <Grid container item>
                                <span className={classes.blueRound} />
                                <span className={classes.yellowRound} />
                                <Grid container direction="column">
                                    {/* Header banner */}
                                    <Grid container>
                                        <div>
                                            <img width="75%" src={login_bg_mobile} alt="bg" />
                                        </div>
                                    </Grid>

                                    {/* Logo */}
                                    <div>
                                        <a href={logoLink} target={"_blank"} rel="noreferrer">
                                            <img
                                                style={{ maxWidth: "100%" }}
                                                src={LoginIcon}
                                                alt={"icon"}
                                                className={classes.loginIcon}
                                            />
                                        </a>
                                    </div>

                                    {/* Reset password form */}
                                    <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                                        <Grid container direction={"column"} className={classes.loginFormContainer}>
                                            <Grid item style={{ lineHeight: 1.1 }}>
                                                <div className={classes.welcomeFont}>Welcome to EHP</div>
                                                <div className={classes.welcomeFont}>
                                                    Data Collaboration Laboratory Portal{" "}
                                                    {process.env.REACT_APP_ENV_DESC || ""}
                                                </div>
                                            </Grid>

                                            <Grid item container direction={"column"} className={classes.loginInputBox}>
                                                <Grid item className={classes.loginFont}>
                                                    RESET PASSWORD
                                                </Grid>

                                                {/* Email (read-only) */}
                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="email" className={classes.blackColor}>
                                                            Email
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    {...register("email")}
                                                                    error={!!errors?.email}
                                                                    helperText={errors?.email?.message}
                                                                    variant="standard"
                                                                    InputProps={{ className: classes.inputStyle }}
                                                                    inputProps={{ maxLength: 128 }}
                                                                    disabled
                                                                />
                                                            )}
                                                            id={"email"}
                                                            name="email"
                                                            control={control}
                                                            rules={{ required: true }}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                {/* New Password */}
                                                <Grid item className={classes.loginPwdInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="pwd" className={classes.blackColor}>
                                                            New Password
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    type={showNewPassword ? "text" : "password"}
                                                                    error={!!errors?.pwd}
                                                                    helperText={errors?.pwd?.message}
                                                                    style={{ height: "30px" }}
                                                                    variant="standard"
                                                                    InputProps={{
                                                                        className: classes.inputStyle,
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    aria-label="toggle new password visibility"
                                                                                    onClick={handleClickShowNewPassword}
                                                                                    onMouseDown={handleMouseDownPassword}
                                                                                    style={{ color: "black" }}
                                                                                    size="large"
                                                                                >
                                                                                    {showNewPassword ? (
                                                                                        <Visibility />
                                                                                    ) : (
                                                                                        <VisibilityOff />
                                                                                    )}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ),
                                                                    }}
                                                                    inputProps={{
                                                                        maxLength: 48,
                                                                        style: {
                                                                            fontFamily:
                                                                                showNewPassword ||
                                                                                "text-security-disc",
                                                                        },
                                                                    }}
                                                                />
                                                            )}
                                                            control={control}
                                                            rules={{ required: true }}
                                                            id="pwd"
                                                            name="pwd"
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                {/* Confirm New Password */}
                                                <Grid item className={classes.loginPwdInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel
                                                            htmlFor="confirmPassword"
                                                            className={classes.blackColor}
                                                        >
                                                            Confirm New Password
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    type={showConfirmPassword ? "text" : "password"}
                                                                    error={!!errors?.confirmPassword}
                                                                    helperText={errors?.confirmPassword?.message}
                                                                    style={{ height: "30px" }}
                                                                    variant="standard"
                                                                    InputProps={{
                                                                        className: classes.inputStyle,
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    aria-label="toggle confirm password visibility"
                                                                                    onClick={
                                                                                        handleClickShowConfirmPassword
                                                                                    }
                                                                                    onMouseDown={handleMouseDownPassword}
                                                                                    style={{ color: "black" }}
                                                                                    size="large"
                                                                                >
                                                                                    {showConfirmPassword ? (
                                                                                        <Visibility />
                                                                                    ) : (
                                                                                        <VisibilityOff />
                                                                                    )}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ),
                                                                    }}
                                                                    inputProps={{
                                                                        maxLength: 48,
                                                                        style: {
                                                                            fontFamily:
                                                                                showConfirmPassword ||
                                                                                "text-security-disc",
                                                                        },
                                                                    }}
                                                                />
                                                            )}
                                                            control={control}
                                                            id="confirmPassword"
                                                            name="confirmPassword"
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                {/* Submit */}
                                                <Grid item className={classes.LoginBtnWrapper}>
                                                    <FormControl>
                                                        <Button
                                                            type="submit"
                                                            variant="contained"
                                                            color="primary"
                                                            style={{
                                                                textTransform: "none",
                                                                fontFamily: "Quicksand-SemiBold",
                                                                fontSize: 16,
                                                            }}
                                                        >
                                                            Reset
                                                        </Button>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>

                                            {/* Back to login */}
                                            <Grid item container className={classes.signupNow}>
                                                <Link href={"/login"} className={classes.signupLink}>
                                                    Back to login
                                                </Link>
                                            </Grid>
                                        </Grid>
                                    </form>

                                    {/* Useful Information panel */}
                                    <Grid container style={{ flex: 1, minHeight: 90, position: "relative" }}>
                                        <div
                                            className={classes.InfoWrapper}
                                            style={{ position: "absolute", top: 0, left: 0, height: "100%" }}
                                        >
                                            <Typography color={"primary"} className={classes.titleFont}>
                                                USEFUL INFORMATION
                                            </Typography>
                                            <Divider className={classes.InfoDivider} />
                                            <div className={classes.InfoContainer}>
                                                {Array.isArray(usefulInfo) &&
                                                    usefulInfo.length > 0 &&
                                                    usefulInfo.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            dangerouslySetInnerHTML={{ __html: item.content }}
                                                        />
                                                    ))}
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </ThemeProvider>
                </StyledEngineProvider>

                <LockPromptDialog open={showLockTip} onClose={handleLockClose} content={lockTipContent} />
            </div>
        </div>
    );
};

export default ResetPwdMobile;
